import { FillScreen, HStack, VStack } from "@/components/Layout";
import RootHeader from "@/components/Layout/RootHeader";
import { FullScreenOverlay, ViewportLoader } from "@/components/Loading";
import Sidebar from "@/components/Sidebar";
import { useAuthStore } from "@/lib/auth";
import { cn } from "@/lib/cn";
import { EnvMode } from "@/lib/env/feature-flag";
import { useGlobalLoadingStore } from "@/lib/store/loading";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy, memo, useState } from "react";
import { useShallow } from "zustand/shallow";
export const Route = createFileRoute("/_staff")({
  component: StaffLayout,
});

/** @see https://tanstack.com/router/latest/docs/framework/react/devtools */
const TanStackRouterDevtools =
  process.env.NODE_ENV === EnvMode.production
    ? () => null
    : lazy(() =>
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        })),
      );

function StaffLayout() {
  const { isLoading, message } = useGlobalLoadingStore();

  return (
    <>
      {/* 組織切り替えなどのグローバルな状態変更時はFullScreenOverlayを使用してユーザー操作をブロック */}
      {isLoading && <FullScreenOverlay message={message} />}
      <StaffLayoutWithSidebar />
    </>
  );
}

const StaffLayoutWithSidebar = memo(function StaffLayoutWithSidebar() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const refreshUserSession = useAuthStore(
    useShallow(({ refreshUserSession }) => refreshUserSession),
  );

  return (
    <FillScreen className="bg-neutral-bottom-fill">
      <VStack className="h-full">
        <RootHeader />
        <HStack className="flex-1 overflow-hidden">
          <Sidebar
            isOpen={isSidebarOpen}
            setIsOpen={setIsSidebarOpen}
            refreshUserSession={refreshUserSession}
          />
          <main className={cn("flex-1 overflow-auto")}>
            <div className="h-full">
              <Suspense fallback={<ViewportLoader />}>
                <Outlet />
              </Suspense>
            </div>
          </main>
          <Suspense>
            <TanStackRouterDevtools />
          </Suspense>
        </HStack>
      </VStack>
    </FillScreen>
  );
});
